/** Strings the console chrome owns. Nothing here belongs to a feature. */
export const chromeCopy = {
  brandName: 'شاهدني',
  consoleName: 'وحدة التحكّم',
  /** The lockup's accessible name — the mark plus where it leads. */
  brandLink: 'شاهدني — لوحة التشغيل',

  nav: {
    label: 'أسطح التشغيل',
    listLabel: 'التنقّل الرئيسي',
    heading: 'التنقّل',
    open: 'افتح قائمة التنقّل',
    close: 'أغلق قائمة التنقّل',
  },

  topbar: {
    label: 'الشريط العلوي',
    create: 'أضف عنواناً',
  },

  crumbs: {
    label: 'فتات الطريق',
  },

  inbox: {
    /** The count is written into the link's name, so the visible badge is `aria-hidden`. */
    label: (unread: string) => `الإشعارات — ${unread} غير مقروءة`,
    labelEmpty: 'الإشعارات',
  },

  account: {
    label: (name: string) => `حساب ${name}`,
    panel: 'قائمة الحساب',
    /** The role word beside the issuing host. Both are session facts, not preferences. */
    operator: 'مشغّل',
    admin: 'مدير',
  },

  footer: {
    label: 'تذييل',
    linksLabel: 'روابط الموقع',
    about: 'من نحن',
    contact: 'اتصل بنا',
  },
} as const;

/**
 * The public site's origin — read from the environment, never compiled in.
 *
 * It is the target of the only outbound links this shell draws: the two
 * informational pages, and every «افتح الصفحة العامّة» beside a person. The
 * console renders none of them and never imports the sibling's bundle.
 *
 * **A deployment fact, so it is a deployment value.** It was the literal
 * `https://shahedni.com`, which is the production host and exists on no other
 * environment: every one of these links on develop pointed at a site that is not
 * there, from a console whose own API, storage and hosts are all develop's.
 *
 * The production host stays the fallback, so an unset variable degrades to the
 * value this constant used to hold rather than to a broken relative link.
 */
export const PUBLIC_SITE_ORIGIN =
  import.meta.env.VITE_LANDING_BASE_URL?.replace(/\/+$/, '') || 'https://shahedni.com';
